import { render } from "./Modal.vue?vue&type=template&id=aae0b236&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=aae0b236&lang=scss&scoped=true"

import exportComponent from "/home/nootaku/dev/clickado_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aae0b236"]])

export default __exports__